import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import Media from "react-media";
import ExperienceSpecialDashboard from "./ExperienceSpecialDashboard";

const MainExpSpecialDashboard = () => {
  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Media query="(min-width: 992px)">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
          </Media>
          <div className="right-side-panel">
            <RightSideNavigation pageTitle="Occasions & Special Experience Dashboard" />
            <Container fluid className="p-0">
              <ExperienceSpecialDashboard />
            </Container>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default MainExpSpecialDashboard;
